import React from 'react'
export function getFolderIcon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path stroke="#156a7d" d="M0 0h16M0 1h16M0 2h16M0 3h16M0 4h3M8 4h8M0 5h3M8 5h8M0 6h3M13 6h3M0 7h3M13 7h3" />
      <path stroke="#6de4ff" d="M3 4h3M3 5h3M3 6h10M3 7h10M3 8h10M3 9h10M3 10h10M3 11h10" />
      <path stroke="#0c404c" d="M6 4h2M6 5h2" />
      <path stroke="#013d4b" d="M0 8h3M13 8h3M0 9h3M13 9h3M0 10h3M13 10h3M0 11h3M13 11h3M0 12h16M0 13h16M0 14h16M0 15h16" />
    </svg>
  )
}

export function getOffenseIcon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path style={{fill:"#81455b"}} d="M0 8h16v8H0z"/>
      <path style={{fill:"#e9735f"}} d="M0 0h16v8H0z"/>
      <path style={{fill:"#f0b07"}}
            d="M14 2h-2v1h-1v1h-1v1H9v1H8v1H7v1H6V7H4v1h1v2H4v1H3v1H2v2h2v-1h1v-1h1v-1h2v1h1v-2H8V9h1V8h1V7h1V6h1V5h1V4h1V2z"/>
      <path style={{fill:"#f0b07"}}
            d="M12 2h1v1h-1zM11 3h1v1h-1zM10 4h1v1h-1zM9 5h1v1H9zM8 6h1v1H8zM7 7h1v1H7z"/>
    </svg>
  )
}

export function getSupportIcon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path stroke="#e9e15f" d="M0 0h16M0 1h16M0 2h4M6 2h10M0 3h5M7 3h9M0 4h2M3 4h2M7 4h9M0 5h2M7 5h9M0 6h3M8 6h8M0 7h6M9 7h7" />
      <path stroke="#4a2d0a" d="M4 2h2M5 3h2M2 4h1M6 4h1M2 5h2M5 5h2M3 6h5M6 7h3M7 8h3M8 9h5M9 10h5M9 11h2M13 11h1M9 12h2M10 13h2" />
      <path stroke="#865419" d="M5 4h1M4 5h1" />
      <path stroke="#e9aa5f" d="M0 8h7M10 8h6M0 9h8M13 9h3M0 10h9M14 10h2M0 11h9M11 11h2M14 11h2M0 12h9M11 12h5M0 13h10M12 13h4M0 14h16M0 15h16" />
    </svg>
  )
}


export function getItemIcon(width, style={}) {
 return (
   <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
     <path stroke="#d77bba" d="M0 0h16M0 1h16M0 2h7M8 2h8M0 3h8M9 3h7M0 4h7M8 4h8M0 5h4M11 5h5M0 6h4M13 6h3M0 7h4M11 7h1M13 7h3" />
     <path stroke="#a86b95" d="M7 2h1M8 3h1M7 4h1" />
     <path stroke="#1a0513" d="M4 5h1M4 6h1M4 7h1M4 8h1M4 9h1M11 9h1M4 10h1M4 11h1M5 12h1" />
     <path stroke="#510f3c" d="M5 5h1" />
     <path stroke="#370828" d="M6 5h5M5 6h8M5 7h6M12 7h1M5 8h6M12 8h1M5 9h6M12 9h1M5 10h8M5 11h6M6 12h4" />
     <path stroke="#a05ab8" d="M0 8h4M11 8h1M13 8h3M0 9h4M13 9h3M0 10h4M13 10h3M0 11h4M11 11h5M0 12h5M10 12h6M0 13h16M0 14h16M0 15h16" />
   </svg>
 )
}

export function getStolenItemIcon(width, style={}) {
 return (
   <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
     <path stroke="#767b72" d="M0 0h16M0 1h16M0 2h16M0 3h16M0 4h5M10 4h6M0 5h4M13 5h3M0 6h4M11 6h1M13 6h3M0 7h4M11 7h1M13 7h3" />
     <path stroke="#f1dbf9" d="M5 4h5M4 5h9M4 6h1M7 6h1M10 6h1M12 6h1M4 7h1M6 7h3M10 7h1M12 7h1M4 8h3M8 8h3M12 8h1M4 9h9M5 10h5M6 11h3" />
     <path stroke="#1a0513" d="M5 6h2M8 6h2M5 7h1M9 7h1M7 8h1M11 8h1" />
     <path stroke="#414a3c" d="M0 8h4M13 8h3M0 9h4M13 9h3M0 10h5M10 10h6M0 11h5M10 11h6M0 12h16M0 13h16M0 14h16M0 15h16" />
     <path stroke="#292e26" d="M5 11h1M9 11h1" />
   </svg>
 )
}


export function getDisruptIcon(width, style={}) {
 return (
   <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 16 16">
     <path stroke="#639bff" d="M0 0h16M0 1h16M0 2h16M0 3h3M5 3h2M9 3h2M13 3h3M0 4h2M7 4h2M14 4h2M0 5h2M6 5h4M14 5h2M0 6h3M5 6h6M13 6h3M0 7h4M5 7h6M12 7h4" />
     <path stroke="#040e4c" d="M3 3h2M7 3h2M11 3h2M2 4h1M5 4h1M10 4h1M13 4h1M2 5h1M5 5h1M10 5h1M13 5h1M3 6h2M11 6h2M7 10h2M6 11h1M9 11h1M6 12h1M9 12h1M7 13h2" />
     <path stroke="#7266d1" d="M3 4h1M11 4h1M3 5h1M11 5h1M7 11h1M7 12h1" />
     <path stroke="#463d8b" d="M4 4h1M6 4h1M9 4h1M12 4h1M4 5h1M12 5h1M4 7h1M11 7h1M5 8h1M10 8h1M6 9h1M9 9h1M8 11h1M8 12h1" />
     <path stroke="#6378ff" d="M0 8h4M6 8h4M12 8h4M0 9h5M7 9h2M11 9h5M0 10h7M9 10h7M0 11h6M10 11h6M0 12h6M10 12h6M0 13h7M9 13h7M0 14h16M0 15h16" />
     <path stroke="#251f55" d="M4 8h1M11 8h1M5 9h1M10 9h1" />
   </svg>
 )
}


export function getLockIcon(width, style={}) {
 return (
   <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 16 16">
     <path stroke="#dbe2f5" d="M0 0h16M0 1h16M0 2h16M0 3h16M0 4h7M9 4h7M0 5h6M7 5h2M10 5h6M0 6h6M7 6h2M10 6h6M0 7h6M7 7h2M10 7h6" />
     <path stroke="#576798" d="M7 4h1" />
     <path stroke="#4e5d89" d="M8 4h1M6 5h1M9 5h1M6 6h1M9 6h1M6 7h1M9 7h1M5 8h6M5 9h6M5 10h6" />
     <path stroke="#cad1e5" d="M0 8h5M11 8h5M0 9h5M11 9h5M0 10h5M11 10h5M0 11h5M11 11h5M0 12h16M0 13h16M0 14h16M0 15h16" />
     <path stroke="#435281" d="M5 11h6" />
   </svg>
 )
}

export function getSpeechIcon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path stroke="#e9735f" d="M0 0h16M0 1h16M0 2h16M0 3h16M0 4h3M13 4h3M0 5h2M14 5h2M0 6h2M14 6h2M0 7h2M14 7h2" />
      <path stroke="#000000" d="M3 4h10M2 5h1M13 5h1M2 6h1M13 6h1M2 7h1M13 7h1M2 8h1M13 8h1M2 9h1M13 9h1M3 10h7M12 10h1M9 11h1M11 11h1M9 12h2" />
      <path stroke="#ffffff" d="M3 5h3M3 6h2M3 7h1" />
      <path stroke="#f6f2f2" d="M6 5h7M5 6h8M4 7h9M3 8h10M3 9h10M10 10h2M10 11h1" />
      <path stroke="#81455b" d="M0 8h2M14 8h2M0 9h2M14 9h2M0 10h3M13 10h3M0 11h9M12 11h4M0 12h9M11 12h5M0 13h16M0 14h16M0 15h16" />
    </svg>
  )
}


export function unlockSkin1Icon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 26 26" shapeRendering="crispEdges">
      <path stroke="#eff0f3" d="M0 0h26M0 1h26M0 2h11M12 2h14M0 3h9M13 3h13M0 4h7M19 4h7M0 5h6M20 5h6M0 6h5M21 6h5M0 7h4M22 7h4M0 8h4M22 8h4M0 9h4M22 9h4M0 10h3M23 10h3M0 11h3M23 11h3M0 12h2M24 12h2M0 13h2M24 13h2M0 14h2M24 14h2" />
      <path stroke="#222034" d="M11 2h1M9 3h2M12 3h1M7 4h2M13 4h6M6 5h1M19 5h1M5 6h1M20 6h1M4 7h1M21 7h1M4 8h1M21 8h1M4 9h1M21 9h1M3 10h2M21 10h2M3 11h1M22 11h1M2 12h2M22 12h2M2 13h2M22 13h2M2 14h2M22 14h2M2 15h3M8 15h3M15 15h3M21 15h3M3 16h3M7 16h1M11 16h1M14 16h1M18 16h1M20 16h1M22 16h1M3 17h2M6 17h2M11 17h4M18 17h2M21 17h2M4 18h2M7 18h1M11 18h1M14 18h1M18 18h1M20 18h2M4 19h2M8 19h3M15 19h3M20 19h2M5 20h2M19 20h2M5 21h4M17 21h4M5 22h1M7 22h1M9 22h8M18 22h1M20 22h1M5 23h1M7 23h1M18 23h1M20 23h1M5 24h1M7 24h12M20 24h1M6 25h2M18 25h2" />
      <path stroke="#e5dc20" d="M11 3h1M9 4h4M7 5h2M11 5h7M20 8h1M5 9h1M20 9h1M5 10h1M20 10h1M4 11h2M20 11h2M4 12h2M21 12h1M4 13h1M21 13h1M4 14h1M6 14h1M16 14h1M21 14h1M13 15h1" />
      <path stroke="#f3eb33" d="M9 5h2" />
      <path stroke="#fbf236" d="M18 5h1M6 6h14M5 7h3M10 7h3M14 7h7M5 8h2M11 8h1M15 8h5M6 9h1M11 9h2M14 9h4M19 9h1M6 10h2M10 10h5M16 10h3M6 11h10M17 11h2M6 12h11M18 12h1M20 12h1M5 13h12M18 13h3M7 14h3M12 14h2M17 14h1M19 14h1" />
      <path stroke="#fffa8b" d="M8 7h2M13 7h1M7 8h4M12 8h3M7 9h4M13 9h1M18 9h1M8 10h2M15 10h1M19 10h1M16 11h1M19 11h1M17 12h1M19 12h1M17 13h1M18 14h1M18 15h1" />
      <path stroke="#e5916c" d="M5 14h1M10 14h2M15 14h1M5 15h1M12 15h1M12 16h2M9 21h1M16 21h1" />
      <path stroke="#f4a37a" d="M14 14h1M6 15h2M19 15h1M21 16h1M5 17h1M20 17h1M6 18h1M12 18h2M19 18h1M6 19h1M12 19h2M19 19h1M7 20h5M14 20h5M10 21h6M6 24h1M19 24h1" />
      <path stroke="#bd785a" d="M20 14h1M20 15h1M6 16h1M19 16h1" />
      <path stroke="#dbe2f0" d="M0 15h2M24 15h2M0 16h3M23 16h3M0 17h3M23 17h3M0 18h4M22 18h4M0 19h4M22 19h4M0 20h5M21 20h5M0 21h5M21 21h5M0 22h5M21 22h5M0 23h5M21 23h5M0 24h5M21 24h5M0 25h6M20 25h6" />
      <path stroke="#2e2a4b" d="M11 15h1M14 15h1M7 19h1M11 19h1M14 19h1M18 19h1" />
      <path stroke="#fdfeff" d="M8 16h2M15 16h2M8 17h1M15 17h1" />
      <path stroke="#d5e3f7" d="M10 16h1M17 16h1M9 17h2M16 17h2M8 18h3M15 18h3" />
      <path stroke="#7e0b16" d="M12 20h2" />
      <path stroke="#847e87" d="M6 22h1M8 22h1M19 22h1M6 23h1M8 23h3M19 23h1" />
      <path stroke="#695d6e" d="M17 22h1M15 23h3" />
      <path stroke="#746a79" d="M11 23h4" />
      <path stroke="#d2dee2" d="M8 25h1" />
      <path stroke="#cee6ef" d="M9 25h4M14 25h3" />
      <path stroke="#acbac0" d="M13 25h1" />
      <path stroke="#bbcae7" d="M17 25h1" />
    </svg>
  )
}
export function unlockSkin2Icon(width, style={}) {
  return (
    <svg style={{minWidth: "16px", ...style}} width={width} height={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 26 26" shapeRendering="crispEdges">
      <path stroke="#eff0f3" d="M0 0h26M0 1h26M0 2h26M0 3h26M0 4h26M0 5h26M0 6h9M18 6h8M0 7h7M20 7h6M0 8h6M21 8h5M0 9h6M21 9h5M0 10h5M22 10h4M0 11h5M22 11h4M0 12h4M22 12h4M0 13h4M22 13h4M0 14h4M22 14h4" />
      <path stroke="#1f0535" d="M9 6h9M7 7h2M18 7h2M6 8h1M20 8h1M6 9h1M20 9h1M5 10h1M21 10h1M5 11h1M21 11h1M4 12h1M8 12h1M10 12h1M15 12h1M18 12h1M21 12h1M4 13h1M7 13h1M19 13h1M21 13h1M4 14h1M6 14h1M19 14h1M21 14h1M4 15h1M6 15h1M21 15h1M4 16h1M6 16h1M10 16h1M15 16h1M19 16h1M21 16h1M4 17h1M6 17h1M10 17h1M15 17h1M19 17h1M21 17h1M4 18h1M6 18h1M10 18h1M15 18h1M19 18h1M21 18h1M4 19h1M6 19h1M19 19h1M21 19h1M5 20h1M7 20h1M18 20h1M20 20h1M5 21h2M8 21h1M17 21h1M19 21h2M5 22h1M7 22h1M9 22h8M18 22h1M20 22h1M5 23h1M7 23h1M11 23h1M14 23h1M18 23h1M20 23h1M5 24h1M7 24h2M12 24h1M15 24h1M18 24h1M20 24h1M6 25h14" />
      <path stroke="#adbbea" d="M9 7h2M7 8h5M7 9h5M8 10h3" />
      <path stroke="#8b9ddd" d="M11 7h7M12 8h7M12 9h8M6 10h2M11 10h1M13 10h3M17 10h4M6 11h5M14 11h1M19 11h2M5 12h3M20 12h1M6 13h1M13 23h1M15 23h2" />
      <path stroke="#748ad7" d="M19 8h1M16 10h1M15 11h1M17 11h2M19 12h1M5 13h1M5 14h1M5 15h1M5 16h1M5 17h1M5 18h1M5 19h1M6 22h1M8 22h1M19 22h1M6 23h1M8 23h3M12 23h1M19 23h1M9 24h3M13 24h2M16 24h2" />
      <path stroke="#82571d" d="M12 10h1M11 11h1M13 11h1M16 11h1M9 12h1M14 12h1M17 12h1M8 13h1M12 13h1M14 13h1M18 13h1M7 14h2M10 14h2M13 14h3M17 14h2M7 15h1M9 15h1M12 15h1M19 15h1" />
      <path stroke="#ae6a0f" d="M12 11h1M11 12h3M16 12h1M9 13h3M13 13h1M15 13h3M9 14h1M12 14h1M16 14h1" />
      <path stroke="#7186cd" d="M20 13h1M20 14h1M20 15h1M20 16h1M20 17h1M20 18h1M20 19h1M6 20h1M19 20h1M18 21h1" />
      <path stroke="#dbe2f0" d="M0 15h4M22 15h4M0 16h4M22 16h4M0 17h4M22 17h4M0 18h4M22 18h4M0 19h4M22 19h4M0 20h5M21 20h5M0 21h5M21 21h5M0 22h5M21 22h5M0 23h5M21 23h5M0 24h5M21 24h5M0 25h6M20 25h6" />
      <path stroke="#c8896e" d="M8 15h1M10 15h2M13 15h6" />
      <path stroke="#d98f6a" d="M7 16h1M7 17h1M7 18h1M7 19h1" />
      <path stroke="#e99976" d="M8 16h2M11 16h4M17 16h2M8 17h1M8 18h1M8 19h1M17 19h2M8 20h1M17 20h1M9 21h1M16 21h1" />
      <path stroke="#f6b594" d="M16 16h1M16 17h1M16 18h1" />
      <path stroke="#fca87e" d="M9 17h1M11 17h4M18 17h1M9 18h1M11 18h1M18 18h1M9 19h8M9 20h3M14 20h3M10 21h2M14 21h2" />
      <path stroke="#f4a37a" d="M17 17h1M17 18h1" />
      <path stroke="#f5ac87" d="M12 18h3" />
      <path stroke="#e87171" d="M12 20h2" />
      <path stroke="#465ba3" d="M7 21h1" />
      <path stroke="#f7b796" d="M12 21h2" />
      <path stroke="#9dade3" d="M17 22h1M17 23h1" />
      <path stroke="#e19975" d="M6 24h1M19 24h1" />
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/icon-svg-getters/icon-folder.js